import { render, staticRenderFns } from "./PillSelector.vue?vue&type=template&id=c01e77e2&scoped=true&"
import script from "./PillSelector.vue?vue&type=script&lang=js&"
export * from "./PillSelector.vue?vue&type=script&lang=js&"
import style0 from "./PillSelector.vue?vue&type=style&index=0&id=c01e77e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01e77e2",
  null
  
)

export default component.exports